document.addEventListener('DOMContentLoaded', () => {
  const teamGridModules = document.querySelectorAll('.a-team-grid')

  teamGridModules.forEach((gridModule) => {
    const members = gridModule.querySelectorAll('.unit__member')
    setOffsetMembers()
    window.addEventListener('resize', () => {
      setOffsetMembers()
    })

    function setOffsetMembers () {
      if (window.innerWidth >= 768 && window.innerWidth <= 991) {
        members.forEach((member, index) => {
          if (index % 2 !== 0) {
            member.style.transform = 'translateY(-40%)'
          }
        })
      } else {
        members.forEach((member, index) => {
          if (index % 2 !== 0) {
            member.style.transform = 'none'
          }
        })
      }
    }
  })
})
